/**
 * True when any of these offerings is a pool in an FDIC sale. FDIC sale data leaves the platform
 * only as protected, watermarked documents, so raw exports built in the browser are withheld
 * wherever one of these offerings would be in the file.
 */
export const includesFdicSaleOffering = (
  offerings: ReadonlyArray<{ sale_id: string | null } | null | undefined>,
): boolean => offerings.some((offering) => offering?.sale_id != null);
